<template>
    <v-footer color="black" tile class="py-0 mt-9">
        <v-container class="py-0">
            <v-row>
                <v-col cols="12" class="py-6">
                    <h3>{{ $store.state.client_vars.footer.footerHeader }}</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col sm="auto" cols="12" class="py-sm-0" v-for="item in footerArr" :key="item.id">
                    <h4 class="mb-0">
                        {{ item.title }}
                    </h4>
                    <div v-html="item.content">
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="py-6">
                    <hr />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="auto" class="pb-4 pt-0 mr-auto">
                    <p class="copyright">
                        ©{{ $store.state.client_vars.footer.footerCopyright }}
                    </p>
                </v-col>
                <v-col cols="auto" class="pb-4 pt-0 ">
                    <img src="@/assets/new-zealand-government-grey.svg" alt=""/>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script>
    export default {
        data() {
            return {
                footerArr: []
            }
        },
        mounted() {
            this.$axios.get(this.$store.state.client_vars.FOOTER)
                .then(response => {
                    this.footerArr = response.data
                })
                .catch(error => {
                    console.log('Failed to update footer links')
                })
        }
    }
</script>

<style lang="scss">

.v-footer {
    hr {
        background-color: #979797;
        opacity: 0.2;
    }

    p, a {
        font-size: 16px;
        color: white;
        font-weight: 500;
        text-decoration: none;;
        margin-bottom: 0;

        &.copyright {
            font-size: 12px;
            font-weight: 500;
            color: #888888;
        }
    }

    a {
        color: white!important;
    }

    h3 {
        color: white;
        font-size: 18px;
    }

    h4 {
        color: var(--v-secondary-base);
        font-size: 18px;
        line-height: 24px;
    }

    p {
        font-size: 16px;
        line-height: 24px;
    }
}
</style>